// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3qp7E","dragIcon":"Choice_dragIcon__3xER-","left":"Choice_left__ErgIk","input":"Choice_input__1crlG"};